import {
  BatteryInfo,
  Device,
  DeviceId,
  DeviceInfo,
  GetLanguageCodeResult,
} from "@src-capacitor/@capacitor/device"
import { defineStore } from "pinia"

export interface CapacitorDeviceInfoStoreType {
  deviceId: DeviceId | null
  deviceInfo: DeviceInfo | null
  languageCode: GetLanguageCodeResult | null
}

export const useCapacitorDeviceInfoStore = defineStore("pinia-capacitorDeviceInfoStore", {
  persist: true,

  state: (): CapacitorDeviceInfoStoreType => ({
    deviceId: null,
    deviceInfo: null,
    languageCode: null,
  }),

  getters: {
    getBattery: async (): Promise<BatteryInfo> => {
      return await Device.getBatteryInfo()
    },
  },

  actions: {
    async setStaticState() {
      this.deviceId = await Device.getId()
      this.languageCode = await Device.getLanguageCode()
    },

    async updateDeviceInfo() {
      this.deviceInfo = await Device.getInfo()
    },
  },
})
